export function updateItemInArray(array: any[] = [], item: any, identifier: string) {

    const itemExists = array && array?.some((arrayItem: any) => arrayItem[identifier] === item[identifier]) || false;

    if (itemExists) {
        return array.map((arrayItem: any) => {
            if (arrayItem[identifier] !== item[identifier]) {
                return arrayItem;
            }

            return {
                ...arrayItem,
                ...item
            };
        });
    } else {
        return [...array, item];
    }
}